export default __webpack_public_path__ + "static/media/shield-check.d539da5d.svg";